import { Box, Stack } from "@mui/material";
import { ProductInventoryPermission } from "commons/enum/permission";
import { Dayjs } from "dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { DateRange } from "share-components/atomics/date-range";
import { AddButton } from "share-components/mui-wrap/button/action-button";
import { SearchButton } from "share-components/mui-wrap/button/search-button";
import { XSearchTextField } from "share-components/mui-wrap/text-field/x-search-text-field";
import { PageContentContainer } from "share-components/templates/page/page-content-container";
import { PageFilterContainer } from "share-components/templates/page/page-filter-container";
import { AddProductGoodsReceipt } from "../add-goods-receipt/add-goods-receipt";
import { UpdateProductGoodsReceipt } from "../update-goods-receipt/update-goods-receipt";
import { ProductGoodsReceiptTable } from "./product-goods-receipt-table";

export const ProductGoodsReceiptList = observer(() => {
  const {
    productInventoryManagement: {
      productGoodsReceiptStore: {
        setProp,
        pagination,
        getProductGoodsReceipt,
        openNew,
        openEdit,
        queryParams: {
          dateRangeFilter: {
            fromAsDayJs,
            toAsDayJs,
            setProp: setDateRangeProps,
          },
          code,
          dealingName,
          name,
          barcode,
          setProp: setQueryParamsProp,
        },
      },
    },
  } = useStores();
  const onSearch = useCallback(async () => {
    pagination.setProp("pageIndex", 0);
    await getProductGoodsReceipt();
  }, [getProductGoodsReceipt, pagination]);

  const fromDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setDateRangeProps("from", value ? value.toString() : null);
    },
    [setDateRangeProps],
  );

  const toDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setDateRangeProps("to", value ? value.toString() : null);
    },
    [setDateRangeProps],
  );
  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="start"
        gap={4}
      >
        <Stack direction="column" gap={2}>
          <DateRange
            label={"Ngày nhập"}
            fromDate={fromAsDayJs}
            toDate={toAsDayJs}
            onFromDateChanged={fromDateChangedHandler}
            onToDateChanged={toDateChangedHandler}
          ></DateRange>
          <PageFilterContainer>
            <XSearchTextField
              label="Tên giao dịch"
              value={dealingName}
              onChange={(e) =>
                setQueryParamsProp("dealingName", e.currentTarget.value)
              }
            ></XSearchTextField>
            <XSearchTextField
              label="Tên hàng"
              value={name}
              onChange={(e) =>
                setQueryParamsProp("name", e.currentTarget.value)
              }
            ></XSearchTextField>
            <XSearchTextField
              label="Mã hàng"
              value={code}
              onChange={(e) =>
                setQueryParamsProp("code", e.currentTarget.value)
              }
            ></XSearchTextField>
            <XSearchTextField
              label="Mã barcode"
              value={barcode}
              onChange={(e) =>
                setQueryParamsProp("barcode", e.currentTarget.value)
              }
            ></XSearchTextField>

            <SearchButton asyncAction={onSearch}></SearchButton>
          </PageFilterContainer>
        </Stack>
        <Box flexShrink={0}>
          <AddButton
            accessPermission={[ProductInventoryPermission.ImportCreate]}
            onClick={() => {
              setProp("openNew", true);
            }}
          >
            Thêm nhập kho
          </AddButton>
        </Box>
      </Stack>
      <PageContentContainer sx={{ marginTop: "10px" }}>
        <ProductGoodsReceiptTable></ProductGoodsReceiptTable>
      </PageContentContainer>

      <>
        {openNew && <AddProductGoodsReceipt></AddProductGoodsReceipt>}
        {openEdit && <UpdateProductGoodsReceipt></UpdateProductGoodsReceipt>}
      </>
    </>
  );
});
